import {h, render} from "preact"
import Cookies from "js-cookie"

// Components
import Popup from "Popup"
import {SERVER_ENDPOINT} from "./const";

// Styles
import "styles.sass"

// constants
const API_BASE_ENDPOINT = SERVER_ENDPOINT + "/api/v1";
const BASE_COOKIE_NAME = "ipolicy__";

const ensureIdIsDefined = (id) => {
    if (typeof id === "undefined") {
        throw new Error("'id' parameter must be defined");
    }
};

module.exports = function(id, options) {
    ensureIdIsDefined(id);

    options = {
        locale: 'en',
        hide: 'button',
        ...options,
    };

    let dataPromise = fetch(`${API_BASE_ENDPOINT}/document/${id}`)
        .then(res => res.json())
    ;

    dataPromise.then(res => {
        /**
         * Check if cookie exists
         */
        let cookie = Cookies.getJSON(BASE_COOKIE_NAME + id);
        if (cookie) {
            let lastUpdatedAt = new Date(cookie.updatedAt);
            let updatedAt = new Date(res.document.updatedAt.date);
            let documentHasBeenUpdated = lastUpdatedAt.getTime() < updatedAt.getTime();

            if (false === documentHasBeenUpdated) {
                return;
            }
        }

        /**
         * Render
         */
        render(
            <Popup
                data={res}
                options={options}
            />,
            document.body
        );

        /**
         * Set cookie
         */
        Cookies.set(BASE_COOKIE_NAME + id, {
            updatedAt: res.document.updatedAt.date
        }, {
            expires: 7
        });
    });
};